import React from 'react';

export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33331 2.66668C3.1565 2.66668 2.98693 2.73691 2.86191 2.86194C2.73688 2.98696 2.66665 3.15653 2.66665 3.33334V12.6667C2.66665 12.8435 2.73688 13.0131 2.86191 13.1381C2.98693 13.2631 3.1565 13.3333 3.33331 13.3333H5.99998C6.36817 13.3333 6.66665 13.6318 6.66665 14C6.66665 14.3682 6.36817 14.6667 5.99998 14.6667H3.33331C2.80288 14.6667 2.29417 14.456 1.9191 14.0809C1.54403 13.7058 1.33331 13.1971 1.33331 12.6667V3.33334C1.33331 2.80291 1.54403 2.2942 1.9191 1.91913C2.29417 1.54406 2.80288 1.33334 3.33331 1.33334H5.99998C6.36817 1.33334 6.66665 1.63182 6.66665 2.00001C6.66665 2.3682 6.36817 2.66668 5.99998 2.66668H3.33331Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1952 4.19527C10.4556 3.93492 10.8777 3.93492 11.1381 4.19527L14.4714 7.52861C14.7317 7.78895 14.7317 8.21106 14.4714 8.47141L11.1381 11.8047C10.8777 12.0651 10.4556 12.0651 10.1952 11.8047C9.93489 11.5444 9.93489 11.1223 10.1952 10.8619L13.0572 8.00001L10.1952 5.13808C9.93489 4.87773 9.93489 4.45562 10.1952 4.19527Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33331 8.00001C5.33331 7.63182 5.63179 7.33334 5.99998 7.33334H14C14.3682 7.33334 14.6666 7.63182 14.6666 8.00001C14.6666 8.3682 14.3682 8.66668 14 8.66668H5.99998C5.63179 8.66668 5.33331 8.3682 5.33331 8.00001Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
